























































































































import { WelcomeLetterQueueStatusEnum } from '@/modules/shared/enums'
import { IStringDictionary, IStringIndexed } from '@/modules/shared/types'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { WelcomeLettersApi } from '../../api/queue/welcomeletters'

@Component({
  components: {
  }
})
export default class Fulfillment extends Vue {
  private loading = false
  private letterStats: Array<IStringIndexed> = []
  private errorMessage = ''

  private windows = [1, 7, 14, 30, 365]
  private window = 7

  private handleWindowUpdate (newWindow: number) {
    this.window = newWindow
  }

  @Watch('window', { immediate: true })
  private async handleWindowChange (newWindow: number, oldWindow: number) {
    if (newWindow !== oldWindow) {
      try {
        this.loading = true
        this.letterStats = await WelcomeLettersApi.getStatistics({ window: this.window.toString() /* , ignoreCache: '1' */ })
      } catch (err) {
        this.errorMessage = err
      } finally {
        this.loading = false
      }
    }
  }

  protected lettersInStatus (status: number) {
    return this.letterStats.find(s => s.status === status)?.lettersInStatus || 0
  }

  public created () {
  }

  public activated () {
  }

  public updated () {
  }

  public destroyed () {
  }

  public deactivated () {

  }
}
